import { Grid } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import MultiSelectDropDown from '../../../reusableComponents/multipleDropdown';
import { useJobFormContext } from '../JobFormContext';
import ErrorText from './ErrorText';
import FormField from './FormField';
import { FormFieldProps } from './FormTypes';
import { Kid } from 'models/Kid';
import AddKids from './AddKids';
import { JobTypeIds, JobTypesWithDependents } from 'models/JobType';
import { useUserContext } from 'UserContext';
interface KidSelectionInputProps {
    kids: FormFieldProps<Kid[]>;
}

export default function KidSelectionInput({ kids }: KidSelectionInputProps) {
    const { form, kidChoices, familyHasKids, familyHasPets } = useJobFormContext();
    const { role } = useUserContext();
    const isPetcare = form.fieldStates.jobTypeId.value === JobTypeIds.PetCare;
    const isOther = ![JobTypeIds.ChildCare, JobTypeIds.PetCare].includes(form.fieldStates.jobTypeId.value);
    const [dropdownChoices, setDropdownChoices] = useState<Kid[]>([]);
    const [displayKidSelection, setDisplayKidSelection] = useState(true);
    const [displayErrorMessage, setDisplayErrorMessage] = useState(false);

    useEffect(() => {
        let choices = [];
        if (form.fieldStates.jobTypeId.value === JobTypeIds.PetCare) {
            choices = kidChoices.filter((kid: Kid) => kid.type === 'PET');
        } else {
            choices = kidChoices.filter((kid: Kid) => kid.type !== 'PET');
        }
        kids.setValue(choices);
        kids.setValid(choices.length > 0 || role === 'business');
        setDropdownChoices(choices);
        setDisplayKidSelection(JobTypesWithDependents.includes(form.fieldStates.jobTypeId.value));
    }, [form.fieldStates.jobTypeId.value]);

    useEffect(() => {
        if (isOther) {
            kids.setValid(true);
        } else {
            kids.setValid(kids.value.length > 0 || role === 'business');
        }
    }, [kids.value]);

    useEffect(() => {
        if (form.fieldStates.jobTypeId.value === JobTypeIds.ChildCare && familyHasKids && !kids.isValid) {
            setDisplayErrorMessage(true);
        } else if (form.fieldStates.jobTypeId.value === JobTypeIds.PetCare && familyHasPets && !kids.isValid) {
            setDisplayErrorMessage(true);
        } else {
            setDisplayErrorMessage(false);
        }
    }, [kids.value, form.fieldStates.jobTypeId.value, kids.isValid]);

    function onChange(event: { target: { value: number[] } }) {
        const newKidIds = event.target.value;
        let newKids = kidChoices.filter((choice) => newKidIds.includes(choice.id));
        kids.setValue(newKids);
        kids.setValid(newKids.length > 0);
    }

    return displayKidSelection ? (
        <FormField style={{ marginTop: 20 }} title={isPetcare ? 'Add Pet(s) Present' : 'Add Kid(s) Present'}>
            <Grid item xs={12}>
                {dropdownChoices && dropdownChoices.length > 0 ? (
                    <MultiSelectDropDown selected={toIds(kids.value)} fields={dropdownChoices} onChange={onChange} />
                ) : (
                    <AddKids />
                )}
                {displayErrorMessage ? (
                    <ErrorText>Please select at least one {isPetcare ? 'pet' : 'child'}</ErrorText>
                ) : null}
            </Grid>
        </FormField>
    ) : null;
}

function toIds(kids: Kid[]) {
    return kids.map((kid) => kid.id);
}
